import { Box, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { EmergencyIcon } from '../../../assets/icons';
import styles from './Tips.module.css';

const Tips: FC = () => {
  return (
    <Box display='flex' flexDirection='column' gap='1rem'>
      <Paper className={styles.tipContent}>
        <Box className={styles.tipHeader}>
          <img src={EmergencyIcon} alt='app-icon' height={22} />
          <Typography variant='h6'>Please pull over if you are driving</Typography>
        </Box>
        <Box className={[styles.tipSection, styles.whiteSmokeSection].join(' ')}>
          <Typography fontSize={14} fontWeight={300}>
            For your safety and to ensure a successful visit, please join the appointment from a
            stationary location, not while driving or in a moving vehicle. Your provider may ask you
            to pull over or reschedule if necessary.
          </Typography>
        </Box>
      </Paper>
      <Paper className={styles.tipContent}>
        <Box className={styles.tipHeader}>
          <Typography variant='h6'>For an optimal telehealth experience:</Typography>
        </Box>
        <Box className={[styles.tipSection, styles.clearDaySection].join(' ')}>
          <Typography fontSize={14} fontWeight={300}>
            Turn on <b>Do Not Disturb/Focus Mode</b> to prevent incoming texts and calls from
            disrupting your appointment
          </Typography>
        </Box>
        <Box className={[styles.tipSection, styles.clearDaySection].join(' ')}>
          <Typography fontSize={14} fontWeight={300}>
            <b>Confirm that you are properly connected.</b> You should see yourself on camera. If
            you cannot see your video, please refresh your browser, and allow access to both your
            camera and microphone.
          </Typography>
        </Box>
        <Box className={[styles.tipSection, styles.whiteSmokeSection].join(' ')}>
          <Typography fontSize={14} fontWeight={300}>
            For additional support, please review these{' '}
            <a
              href='https://mailchi.mp/enarahealth/video-call-troubleshooting'
              target='_blank'
              rel='noopener noreferrer'>
              troubleshooting tips
            </a>
            . Message your provider if you are unable to connect.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Tips;
